module.exports = __webpack_public_path__ + "static/media/external_link.3a5f55ef.svg";